import React, { useState, useEffect } from 'react';
import SliderNavigation from './common/SliderNavigation';
import '../styles/Partners.scss';
import Title from './common/Title';

const Partners = ({ partners }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(5);
  const slideWidth = 220; // width of a single slide + gap

  // 🖥️ Update slidesPerView based on window width
  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 480) setSlidesPerView(1);
      else if (width < 768) setSlidesPerView(2);
      else if (width < 1024) setSlidesPerView(3);
      else if (width < 1200) setSlidesPerView(4);
      else setSlidesPerView(5);
    };

    updateSlides();
    window.addEventListener('resize', updateSlides);
    return () => window.removeEventListener('resize', updateSlides);
  }, []);

  const maxSlideIndex = Math.max(0, partners.length - slidesPerView);

  const nextSlide = () => {
    setCurrentSlide((prev) => Math.min(prev + 1, maxSlideIndex));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => Math.max(prev - 1, 0));
  };

  const canPrev = currentSlide > 0;
  const canNext = currentSlide < maxSlideIndex;

  if (!partners || partners.length === 0) return null;

  return (
    <section className="partners">
      <Title text="OUR PARTNERS" />

      <div className="partners-slider">
        <SliderNavigation
          onPrevClick={prevSlide}
          onNextClick={nextSlide}
          canPrev={canPrev}
          canNext={canNext}
        />

        <div className="partners-container">
          <div
            className="partners-track"
            style={{
              transform: `translateX(-${currentSlide * slideWidth}px)`,
              transition: 'transform 0.4s ease-in-out',
            }}
          >
            {partners && partners.map((partner) => (
              <div key={partner.id} className="partner-item">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="partner-logo"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
